let themeEditorReady = false;
let themeEditorReadyCallback: ICallback = null;

const isReady = (): boolean => themeEditorReady;

const setReady = (): void => {
    themeEditorReady = true;

    if (themeEditorReadyCallback) {
        themeEditorReadyCallback();
    }
};

const onReady = (callback: ICallback): void => {
    if (isReady()) {
        callback();
    } else {
        themeEditorReadyCallback = callback;
    }
};

export const themeEditor = {
    isReady,
    setReady,
    onReady,
};
